// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI, {
  Message
} from 'element-ui';
import '@/assets/lib/css/common.css';
import '@/assets/lib/css/meta.less';
import '@/assets/lib/css/theme.less';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/lib/css/iconfont.css';

import '@/utils/flexible.js'

import ut from '@/assets/lib/js/util.js';
import axios from 'axios'
import store from './store'
import qs from 'qs'

Vue.prototype.ut = ut;

import VCharts from 'v-charts'
Vue.use(VCharts)

import VueAMap from 'vue-amap';
Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
  key: '8aa18bace3c9b3f3e43900a9f3ce74de'
});

Vue.prototype.$axios = axios;

//axios配置
axios.defaults.headers['Accept'] = 'application/json';
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';

var status = process.env.API_ENV_STATUS;

// API根域名
var api_root_host = '';
// 图片根域名
var img_base_host = '';
// 图片域名替换正则
var img_host_remove_reg = '';
// 图片上传API路由
var img_upload_api = '/api/v1/image';
// 图片中转域名
var img_center_host = process.env.IMAGE_CENTER_HOST;

if (typeof status !== 'undefined') {
  switch (status) {
    case "local":
      api_root_host = process.env.API_HOST_LOCAL;
      img_base_host = process.env.MASTER_HOST_LOCAL;
      break;
    case "test":
      api_root_host = process.env.API_HOST_TEST;
      img_base_host = process.env.MASTER_HOST_TEST;
      break;
    case "prod":
      api_root_host = process.env.API_HOST_PROD;
      img_base_host = process.env.MASTER_HOST_PROD;
      break;
    default:
      api_root_host = process.env.API_HOST_LOCAL;
      img_base_host = process.env.MASTER_HOST_LOCAL;
      break;
  }
  if (process.env.API_ENV_STATUS == "prod" || process.env.API_ENV_STATUS == "test") {
    img_upload_api = img_upload_api.replace('/api', '');
  }
  img_host_remove_reg = new RegExp(api_root_host + '|' + img_center_host, 'g');
}

// 请求前
axios.interceptors.request.use(function (config) {
  function configUrl() {
    if (api_root_host === '') {
      return
    } else {
      config.url = config.url.replace('/api', '');
      // console.log(config.url)
      return config.url;
    }
  }
  // 在发送请求之前做些什么
  // console.log(config)
  if (config.method === 'post' && config.headers['Content-Type'] != 'multipart/form-data') {
    //将请求参数进行转换，这里是全局配置post请求参数
    config.data = qs.stringify(config.data)
  }

  // 处理config.url里面多了个api的问题
  if (process.env.API_ENV_STATUS == "prod" || process.env.API_ENV_STATUS == "test") {
    configUrl();
  }

  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
// 响应
axios.interceptors.response.use(function (response) {
  // 未登录拦截
  if (response.data.status == 300) {
    sessionStorage.removeItem("login")
    router.push({
      path: '/login',
      query: { redirect: location.hostname }
    });
  }
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});

// 处理弹框message组件
Vue.prototype.$popup = function (msg, type) {
  // 处理弹框每次只出现一个
  if (document.getElementsByClassName('el-message').length === 0) {
    if (type == 'success') {
      this.$message({
        offset: 300,
        message: msg,
        type: type,
        center: true,
        duration: 800
      });
    } else if (type == 'error') {
      this.$message({
        offset: 300,
        message: msg,
        type: type,
        center: true,
        duration: 2000
      });
    } else {
      this.$message({
        offset: 300,
        message: msg,
        type: "info",
        center: true,
        iconClass: 'iconfont icon-yk_gantanhao_fill',
        customClass: 'user-info',
        duration: 1500
      });
    }
  }
}

// 处理线上图片路径
Vue.prototype.$url = function (path) {
  if (!path) {
    return "./static/img/defaultimg.png";
  }
  function url_check(str) {
    var rule = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
    var reg = new RegExp(rule);
    return reg.test(str);
  }
  if (url_check(path) !== true) {
    let host = img_center_host;
    return host + '/' + path;
  }
  return path;
}
// 处理富文本图片路径
Vue.prototype.$imgBaseHost = img_base_host;
// 处理编辑商品和新增商品的图片正则匹配
Vue.prototype.$goodsImgReg = img_host_remove_reg;
// 图片上传API地址
Vue.prototype.$imgUploadApi = img_upload_api;

// 虚拟页面跳转
Vue.prototype.$addTab = (title, url, params = {}) => {
  store.dispatch("addHeadTab", {
    addTitle: title,
    addUrl: url,
    query: params,
  });
}

// 路由拦截登录状态
router.beforeEach((to, from, next) => {
  // 判断是否是退回到登陆页
  if (to.matched.some(record => record.meta.auth)) {
    if (!sessionStorage.login) {
      next({
        path: "/login"
      });
    } else {
      next();
    }
  } else {
    if (sessionStorage.login) {
      next({
        path: "/home"
      })
    }
    else {
      next();
    }
  }
});

Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js